export class PurposeStatementDto {
    id: number;
    declarationOfResidents: boolean;
    paymentsAbroad: boolean;
    investments: boolean;
    availability: boolean;
    tourism: boolean;
    import: boolean;
    export: boolean;
    receiptsAbroad: boolean;
}
